import React, { type ReactNode, useEffect, useRef, useState } from 'react'

interface ScrollAnimationProps {
  children: ReactNode
  className?: string
  animationClass?: {
    base?: string // 基础样式
    visible?: string // 可见时的样式
    hidden?: string // 隐藏时的样式
  }
  options?: IntersectionObserverInit
  delay?: number // 动画延迟（ms）
}

const ScrollAnimation = ({
  children,
  className = '',
  animationClass = {
    base: 'transition-all duration-1000 ease-out',
    visible: 'opacity-100 translate-y-0',
    hidden: 'opacity-0 translate-y-10',
  },
  options,
  delay = 300,
}: ScrollAnimationProps) => {
  const [isVisible, setIsVisible] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        // 应用延迟效果
        const timer = setTimeout(() => {
          setIsVisible(true)
          observer.unobserve(entry.target)
        }, delay)

        return () => {
          clearTimeout(timer)
        }
      }
    }, options)

    const currentElement = ref.current
    if (currentElement) {
      observer.observe(currentElement)
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement)
      }
    }
  }, [options, delay])

  return (
    <div
      ref={ref}
      className={`${animationClass.base} ${isVisible ? animationClass.visible : animationClass.hidden} ${className}`}
    >
      {children}
    </div>
  )
}

export default ScrollAnimation
